<template>
	<div class="container-fluid">
		<div id="topo" class="card-header">
			<div class="row">
				<div class="col col-xs-2">
					<h4 class="panel-title">
						<span class="title">Consulta de Fornecedores.</span>
						<br />
						<span class="navigation">Fornecedor > Consulta</span>
					</h4>
				</div>
			</div><!--row-->
		</div><!--card-header-->

		<div class="card-body">
			<div class="row">
				<div class="col-md-6 mb-2">
					<label for="filtro">Filtro:</label>
					<span class="p-fluid">
						<InputText type="text" id="filtro" v-model="filtro" />
					</span>
				</div>
				<div class="mb-2">
					<label for="btnSearch">&nbsp;</label>
					<span class="p-fluid">
						<Button label="Pesquisar" title="Pesquisar" icon="pi pi-search" :disabled="search"
							@click="pesquisar()" />
					</span>
				</div>
				<div class="mb-2" style="padding-left:2px">
					<label for="btnSearch">&nbsp;</label>
					<span class="p-fluid">
						<Button label="Limpar" title="Limpar" icon="pi pi-trash" :disabled="search" @click="clear()" />
					</span>
				</div>
			</div><!--row-->

			<div class="row">
				<DataTable :value="fornecedorList" :paginator="true" :rows="10" class="p-datatable-responsive"
					:autoLayout="true">
					<Column headerStyle="width: 8em" bodyStyle="text-align: center">
						<template #body="slotProps">
							<Button type="button" icon="pi pi-pencil" style="margin-right: .5em" @click="detail(slotProps.data.id)"></Button>
							<Button type="button" icon="pi pi-trash" @click="confirmRemove(slotProps.data.id)"></Button>
						</template>
					</Column>
					<Column field="cnpj" header="CNPJ"></Column>
					<Column field="nome" header="Nome"></Column>
				</DataTable>
			</div><!--row-->
			<hr />

			<div class="row">
				<span class="p-fluid mr-2">
					<router-link to="/fornecedorCadastro">
						<Button type="button" icon="pi pi-plus" label="Novo" title="Novo" />
					</router-link>
				</span>
			</div>
		</div><!--card-body-->
		<Dialog header="Aviso" :visible.sync="display" :style="{ width: '30vw' }" :modal="true">
			Confirmar a remoção do Registro?
			<template #footer>
				<Button label="Sim" icon="pi pi-check" @click="remove" title="Sim" />
				<Button label="Não" icon="pi pi-times" @click="close" title="Não" class="p-button-secondary" />
			</template>
		</Dialog>
	</div>
</template>

<script>
import LoginService from "../services/acesso/login.service";
import fornecedorService from "../services/obras/fornecedor.service";

export default {
	name: 'ContribFornecedorConsulta',
	data() {
		return {
			display: false,
			search: false,
			filtro: "",
			fornecedorList: [],
			id: null,
			currentUser: null
		}
	},

	created() {
		this.currentUser = LoginService.currentUserValue;
		this.pesquisar();
	},

	methods: {
		clear() {
			this.filtro = "";
			this.pesquisar();
		},

		pesquisar() {
			this.search = true;
			fornecedorService.findFornecedorByFiltro(
				this.currentUser.contribuinte.idContribuinte,
				this.filtro
			).then(
				fornecedor => {
					this.fornecedorList = fornecedor.data;
				},
				error => {
					let errorMessage = "Houve um problema ao listar Fornecedor!";
					if (error.response) {
						errorMessage = error.response.data;
					}
					this.$toast.add({
						severity: "error",
						summary: errorMessage
					});
				}
			);
			this.search = false;
		},
		detail(id) {
			this.$router.push({ name: "ContribFornecedorCadastro", params: { idFornecedor: id } });
		},
		confirmRemove(id) {
			this.id = id;
			this.display = true;
		},
		close() {
			this.id = null;
			this.display = false;
		},
		remove() {
			fornecedorService.removeFornecedor(this.id).then(
				data => {
					console.log(data);
					this.$toast.add({
						severity: "success",
						summary: "Fornecedor removido com sucesso"
					});
					setTimeout(async () => {
						await this.pesquisar();
						this.display = false;
					}, 250);
				},
				error => {
					let errorMessage = "Houve um problema ao remover o Fornecedor!";
					if (error.response) {
						errorMessage = error.response.data;
					}
					this.$toast.add({
						severity: "error",
						summary: errorMessage
					});
				}
			);
		}
	}
}
</script>